<script lang="ts" setup>
import {computed} from 'vue';
import {useDrawerStore} from '@/ts/store/drawer-store';
import type {
  BalmSidebarMenuItem,
  BalmSidebarType,
} from '@/ts/types/component/balm-sidebar';
import {useTourStore} from '@/ts/store/tour-store';
import {TOUR_NAMES} from '@/ts/utils/tour-constants';
import {useRoute} from 'vue-router';
import {LANGUAGE_REGEX} from '@/ts/utils/consts';

defineProps<{
  sidebarMenuItems: BalmSidebarMenuItem[];
}>();

const drawerStore = useDrawerStore();
const tourStore = useTourStore();
const route = useRoute();

function onClickItem(type: BalmSidebarType): void {
  drawerStore.openBalmSidebarDrawer(type);
}

const isTourAvailable = computed(() => {
  const pathWithoutLang = route.path.replace(LANGUAGE_REGEX.PATH_WITH_LANG, '/');
  return tourStore.isTourAvailableForPath(TOUR_NAMES.onboardingTour, pathWithoutLang);
});

function onClickTour(): void {
  drawerStore.closeHamburgerMenuDrawer();
  tourStore.triggerTour(TOUR_NAMES.onboardingTour);
}
</script>

<template>
  <!-- role=none: items are buttons under Quasar 2.23, not listitems -->
  <q-list class="list js-sidebar-toolbar" role="none">
    <q-item
      v-for="item of sidebarMenuItems"
      :key="item.type"
      class="list-item text-body"
      :class="`js-sidebar-item-${item.type}`"
      clickable
      @click="onClickItem(item.type)"
    >
      {{ $t(item.labelKey) }}
    </q-item>
    <q-item
      v-if="isTourAvailable"
      class="list-item text-body"
      clickable
      @click="onClickTour"
    >
      {{ $t('product_tour') }}
    </q-item>
  </q-list>
</template>

<style lang="scss" scoped>
.list {
  margin-top: var(--Spacing-spacing-3);
  padding-top: var(--Spacing-spacing-3);
  position: relative;
  &:after {
    content: "";
    border-top: 1px solid var(--Neutral-UI-neutral-ui-30);
    top: 0;
    left: var(--Spacing-spacing-3);
    right: var(--Spacing-spacing-3);
    position: absolute;
  }
}

.list-item {
  align-items: center;
  @include focus-visible;
}
</style>
